<script setup></script>

<template>
  <div class="bg-slate-50">
    <slot />
  </div>
</template>
